module.exports = __webpack_public_path__ + "img/ai_speechM.3f755da6.png";